<template>
  <v-menu bottom left :close-on-content-click="false" v-model="menu">
    <template v-slot:activator="{ on }">
      <v-btn small fab icon v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-action> <v-icon>mdi-cogs</v-icon> </v-list-item-action
          >Supplier Details Settings
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-select
            label="Show/Hide"
            multiple
            item-text="label"
            item-value="key"
            :outlined="outlinedInputs"
            :items="allowedTabs"
            v-model="selectedTabs"
            @change="onChange"
          ></v-select>
        </v-list-item>
      </v-list>

      <v-card-actions class="grey lighten-4">
        <div v-if="debug">
          {{ allowedTabs }}
        </div>
        <v-spacer></v-spacer>
        <v-btn text @click="menu = false" color="warning">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "supplier-details-settings",

  props: {
    visibleTabs: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
      menu: false,
      tabs: [
        {
          key: "financial",
          accessSetting: "suppliers:financial",
          label: "Financial",
        },
        {
          key: "services",
          accessSetting: "suppliers:services",
          label: "Services",
        },
        { key: "rates", accessSetting: "suppliers:rates", label: "Rates" },
        { key: "extras", accessSetting: "suppliers:extras", label: "Extras" },
        {
          key: "contents",
          accessSetting: "suppliers:contents",
          label: "Contents",
        },
        {
          key: "discounts",
          accessSetting: "suppliers:discounts",
          label: "Discounts",
        },
        { key: "taxes", accessSetting: "suppliers:taxes", label: "Taxes" },
        {
          key: "allocations",
          accessSetting: "suppliers:allocations",
          label: "Allocations",
        },
        {
          key: "closeouts",
          accessSetting: "suppliers:closeouts",
          label: "Closeouts",
        },
        {
          key: "custom_fields",
          accessSetting: "suppliers:custom_fields",
          label: "Custom Fields",
        },
        {
          key: "histories",
          accessSetting: "suppliers:histories",
          label: "Histories",
        },
        { key: "comps", accessSetting: "suppliers:comps", label: "Comps" },
        { key: "tasks", accessSetting: "plugins:task_tracker", label: "Tasks" },
        {
          key: "service_notes",
          accessSetting: "suppliers:service_notes",
          label: "Service Notes",
        },
        {
          key: "linked_services",
          accessSetting: "suppliers:linked_services",
          label: "Linked Services",
        },
        {
          key: "supplier_portal",
          accessSetting: "suppliers:supplier_portal",
          label: "Supplier Portal",
        },
      ],
      selectedTabs: this.visibleTabs ? [...this.visibleTabs] : [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    allowedTabs() {
      return this.tabs.filter((t) =>
        this.$store.getters.hasAccessTo(t.accessSetting)
      );
    },
  },

  methods: {
    onChange() {
      this.$emit("change", [...this.selectedTabs]);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/SupplierDetailsSettings.vue